import { useTranslation } from 'react-i18next';

/**
 * La foto de alguien, o sus iniciales.
 *
 * Las iniciales y no un icono genérico: en un listado de gente, doce siluetas
 * iguales no distinguen a nadie, y quien todavía no subió foto igual tiene
 * derecho a ser reconocible.
 */
export function Avatar({ url, name, size = 40 }: { url: string | null; name: string; size?: number }): JSX.Element {
  const { t } = useTranslation();
  const style = { width: size, height: size, fontSize: Math.round(size / 2.6) };

  if (url === null) {
    return (
      <span className="avatar avatar-initials" style={style} aria-hidden="true">
        {initials(name)}
      </span>
    );
  }

  return <img className="avatar" style={style} src={url} alt={t('profile.photoOf', { name })} />;
}

/**
 * Hasta dos iniciales. Con `Array.from` para no partir un emoji en dos mitades.
 *
 * AGUANTA QUE NO VENGA NOMBRE, aunque el tipo diga que siempre viene. Un tipo
 * es una promesa sobre el contrato, no una garantía sobre lo que llega por la
 * red: contra una API que omite el campo, `name` llega `undefined` y esto
 * reventaba con «cannot read properties of undefined». Y este componente está
 * en la barra de arriba de TODAS las pantallas, así que ese error no dejaba un
 * círculo vacío: dejaba la aplicación en blanco. Sin nombre se dibuja el
 * círculo sin letras, que se ve incompleto —y es lo que es— pero se ve.
 */
function initials(name: string): string {
  return (name ?? '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => Array.from(word)[0] ?? '')
    .join('')
    .toUpperCase();
}
